// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qr-0";